export const ADDITIONAL_FIELDS_LIMIT = 20;

export const setReflinkFields = (entityUuid, form) => {
  let key = `referrer-${entityUuid}`;
  let referrer = sessionStorage.getItem(key)
  if (referrer) {
    form.referrer = referrer
  }

  for (let i = 1; i <= ADDITIONAL_FIELDS_LIMIT; i++) {
    let key = `additional-${entityUuid}-${i}`;
    let field = sessionStorage.getItem(key);
    if (field) {
      form[`additional${i}`] = field;
    }
  }
}

export const removeReflinkFields = (entityUuid) => {
  sessionStorage.removeItem(`referrer-${entityUuid}`);
  for (let i = 1; i <= ADDITIONAL_FIELDS_LIMIT; i++) {
    let key = `additional-${entityUuid}-${i}`;
    sessionStorage.removeItem(key);
  }
}
